module.exports = __webpack_public_path__ + "static/media/dominik-team-leader.195e11ff.png";